var _style, _defs, _mask, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWrongUserDataRegistryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 37 24",
    style: {
      enableBackground: "new 0 0 37 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D9D9D9;filter:url(#Adobe_OpacityMaskFilter);}\r\n\t.st1{mask:url(#mask0_3560_28487_00000026849898636861704270000004847572807417187998_);}\r\n\t.st2{fill:#15B79E;}\r\n\t.st3{fill:#EF4444;}\r\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 3.7,
    y: 2.1,
    width: 17.2,
    height: 17.9
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 3.7,
    y: 2.1,
    width: 17.2,
    height: 17.9,
    id: "mask0_3560_28487_00000026849898636861704270000004847572807417187998_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.8,
    y: -0.4,
    className: "st0",
    width: 22.9,
    height: 22.9
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M5.1,20v-1h14.3v1H5.1z M5.1,3.1v-1h14.3v1H5.1z M12.2,13c0.7,0,1.2-0.2,1.7-0.7c0.5-0.5,0.7-1,0.7-1.7 c0-0.7-0.2-1.2-0.7-1.7c-0.5-0.5-1-0.7-1.7-0.7c-0.7,0-1.2,0.2-1.7,0.7c-0.5,0.5-0.7,1-0.7,1.7c0,0.7,0.2,1.2,0.7,1.7 C11,12.7,11.6,13,12.2,13z M5.2,17.7c-0.4,0-0.8-0.1-1.1-0.4c-0.3-0.3-0.4-0.7-0.4-1.1V5.9c0-0.4,0.1-0.8,0.4-1.1 c0.3-0.3,0.7-0.4,1.1-0.4h14.1c0.4,0,0.8,0.1,1.1,0.4c0.3,0.3,0.4,0.7,0.4,1.1v10.3c0,0.4-0.1,0.8-0.4,1.1 c-0.3,0.3-0.7,0.4-1.1,0.4H5.2z M7.5,16.8c0.7-0.6,1.5-1.1,2.2-1.4c0.8-0.3,1.6-0.5,2.5-0.5c0.9,0,1.7,0.2,2.5,0.5s1.5,0.8,2.2,1.4 h2.3c0.1,0,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.3,0.2-0.4V5.9c0-0.1-0.1-0.3-0.2-0.4c-0.1-0.1-0.3-0.2-0.4-0.2H5.2 c-0.1,0-0.3,0.1-0.4,0.2C4.7,5.6,4.6,5.8,4.6,5.9v10.3c0,0.1,0.1,0.3,0.2,0.4c0.1,0.1,0.3,0.2,0.4,0.2H7.5z M9.1,16.8h6.3 c-0.5-0.3-1-0.6-1.5-0.7c-0.5-0.2-1.1-0.2-1.7-0.2c-0.6,0-1.1,0.1-1.7,0.2C10.1,16.2,9.6,16.5,9.1,16.8z M12.2,12 c-0.4,0-0.7-0.1-1-0.4c-0.3-0.3-0.4-0.6-0.4-1c0-0.4,0.1-0.7,0.4-1c0.3-0.3,0.6-0.4,1-0.4s0.7,0.1,1,0.4c0.3,0.3,0.4,0.6,0.4,1 c0,0.4-0.1,0.7-0.4,1C13,11.9,12.6,12,12.2,12z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Cancel"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_00000009587428728435139010000015286258672273175729_",
    className: "st3",
    d: "M23.4,15.4l2.9-2.9l2.9,2.9l0.6-0.6L26.8,12 l2.9-2.9l-0.6-0.6l-2.9,2.9l-2.9-2.9l-0.6,0.6l2.9,2.9l-2.9,2.9L23.4,15.4z M26.2,19.2c-1,0-1.9-0.2-2.8-0.6 c-0.9-0.4-1.6-0.9-2.3-1.5c-0.6-0.6-1.2-1.4-1.5-2.3c-0.4-0.9-0.6-1.8-0.6-2.8s0.2-1.9,0.6-2.8c0.4-0.9,0.9-1.6,1.5-2.3 c0.6-0.6,1.4-1.2,2.3-1.5c0.9-0.4,1.8-0.6,2.8-0.6S28.2,5,29,5.4c0.9,0.4,1.6,0.9,2.3,1.5c0.6,0.6,1.2,1.4,1.5,2.3 c0.4,0.9,0.6,1.8,0.6,2.8s-0.2,1.9-0.6,2.8c-0.4,0.9-0.9,1.6-1.5,2.3c-0.6,0.6-1.4,1.2-2.3,1.5C28.2,19,27.2,19.2,26.2,19.2z  M26.2,18.4c1.8,0,3.3-0.6,4.5-1.9c1.2-1.2,1.9-2.7,1.9-4.5c0-1.8-0.6-3.3-1.9-4.5c-1.2-1.2-2.7-1.9-4.5-1.9 c-1.8,0-3.3,0.6-4.5,1.9c-1.2,1.2-1.9,2.7-1.9,4.5c0,1.8,0.6,3.3,1.9,4.5C23,17.8,24.5,18.4,26.2,18.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrongUserDataRegistryIcon);
export default __webpack_public_path__ + "static/media/wrong-user-data-registry-icon.94763e156225f3dfd2c3747a210e4573.svg";
export { ForwardRef as ReactComponent };